module.exports = __webpack_public_path__ + "static/media/fileUploaded.1b84d279.graphql";